/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': 'tilbage',
  'ai-floating-context-menu.ai-dynamic-surface.close': 'luk',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': 'Referencer',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Handlinger',
  'ai-smart-button.ai-actions.conversation-starters.loading.text': 'Samtalestartere indlæses …',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Spørg Rovo',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Giv feedback',
  'ai-smart-button.ai-actions.help.section.text': 'Hjælp',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Link',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Omtal',
  'ai-smart-button.ai-actions.input.placeholder': 'Skriv, hvad du har brug for',
  'ai-smart-button.ai-actions.input.send-button-label': 'Send',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NY',
  'ai-smart-button.ai-actions.no-results-heading': 'Spørg Rovo',
  'ai-smart-button.ai-actions.no-results-text': 'Send din prompt til Rovo for at starte en chat.',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Tilføj ikon',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': 'Agent-ikon',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Ikon for automatisering',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatiseringer',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': 'Gennemse agenter',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Opret agent',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Opret automatisering',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-actions.static-agent-fallback-1': 'Hvad er Rovo-agenter?',
  'ai-smart-button.ai-actions.static-agent-fallback-2': 'Hvordan kan jeg bruge Rovo-agenter i mit Confluence-område?',
  'ai-smart-button.ai-actions.static-fallback-1': 'Hvad er Rovo Chat?',
  'ai-smart-button.ai-actions.static-fallback-2': 'Hjælp mig med at komme i gang med Rovo Chat',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'Hvad kan jeg hjælpe med?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Hej {name}',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Luk',
  'ai-smart-button.feedback-action.ask-question-option': 'Stil et spørgsmål',
  'ai-smart-button.feedback-action.can-contact-message':
    'Ja, {product}-teams kan kontakte mig for at lære om mine oplevelser for at forbedre Atlassian-produkter og -tjenester. Jeg accepterer {privacyPolicy}',
  'ai-smart-button.feedback-action.can-contact-message-appify':
    'Ja, {product}-teams må gerne kontakte mig for at høre om mine oplevelser med henblik på at forbedre Atlassian-apps og -tjenester. Jeg accepterer {privacyPolicy}',
  'ai-smart-button.feedback-action.cancel-button-label': 'Annuller',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Vælg en svarmulighed',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Beskriv fejlen eller problemet',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Fortæl os, hvad du har på hjerte',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'Hvad vil du gerne vide?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Fortæl os, hvad du gerne så forbedret',
  'ai-smart-button.feedback-action.leave-comment-option': 'Skriv en kommentar',
  'ai-smart-button.feedback-action.privacy-policy-link': '{product}s fortrolighedspolitik.',
  'ai-smart-button.feedback-action.report-bug-option': 'Rapportér en fejl',
  'ai-smart-button.feedback-action.research-participation-message': 'Jeg vil gerne deltage i produktundersøgelser',
  'ai-smart-button.feedback-action.select-feedback-heading': 'Vælg feedback',
  'ai-smart-button.feedback-action.submit-button-label': 'Send feedback',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Foreslå en forbedring',
  'ai-smart-button.feedback-action.title': 'Giv feedback',
  'ai-smart-button.feedback-item.icon-label': 'Feedback-ikon',
  'ai-smart-button.reference.close-button-label': 'Luk',
  'ai-smart-button.tooltip.label': 'Spørg Rovo AI',
  'quick-summary.feedback.summary.placeholder': 'Hvad gjorde Atlassian Intelligence godt? Hvad kan forbedres?',
  'quick-summary.feedback.title': 'Hjælp os med at forbedre Atlassian Intelligence',
};
